import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
const CLASSES = ['Essential', 'Signature', 'Majestic', 'Reserve', 'Not sure yet'];

const DriveWithUs = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', vehicle_class: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | done | error
  const [error, setError] = useState('');

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) { setError('Please fill in your name, email and phone.'); return; }
    setStatus('sending'); setError('');
    try {
      const res = await fetch(`${API}/api/driver-applications`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('failed');
      setStatus('done');
    } catch (err) {
      setStatus('error'); setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
      <div className="max-w-2xl mx-auto px-6 py-10">
        <button data-testid="drive-back-btn" onClick={() => navigate('/')} className="text-sm text-gray-400 hover:text-white mb-8">← Back</button>

        <p className="text-[11px] tracking-[0.35em] uppercase text-orange-400 mb-4">Chauffeurs</p>
        <h1 className="text-4xl sm:text-5xl font-medium leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
          Drive with RideBuraq.
        </h1>
        <p className="text-gray-300/90 leading-relaxed mb-10 max-w-lg">
          We partner with professional, independent chauffeurs who hold their own TLC and insurance.
          Tell us a little about you and your vehicle — our team will reach out with next steps.
        </p>

        {status === 'done' ? (
          <div data-testid="drive-success" className="rounded-2xl border border-orange-500/30 bg-orange-500/[0.06] p-8 text-center">
            <h2 className="text-2xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Thank you.</h2>
            <p className="text-gray-300">Our team will be in touch shortly at {form.email}.</p>
            <button data-testid="drive-home-btn" onClick={() => navigate('/')} className="mt-6 px-6 py-3 rounded-full bg-orange-500 text-black font-medium hover:bg-orange-400 transition-colors">Back to home</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Full name</label>
              <input data-testid="drive-name" value={form.name} onChange={update('name')} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-orange-500 focus:outline-none" placeholder="Your name" />
            </div>
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Email</label>
                <input data-testid="drive-email" type="email" value={form.email} onChange={update('email')} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-orange-500 focus:outline-none" placeholder="you@email.com" />
              </div>
              <div>
                <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Phone</label>
                <input data-testid="drive-phone" value={form.phone} onChange={update('phone')} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-orange-500 focus:outline-none" placeholder="(555) 555-5555" />
              </div>
            </div>
            <div>
              <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Which vehicle class fits your car?</label>
              <select data-testid="drive-class" value={form.vehicle_class} onChange={update('vehicle_class')} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-orange-500 focus:outline-none">
                <option value="" className="bg-gray-900">Select…</option>
                {CLASSES.map((c) => <option key={c} value={c} className="bg-gray-900">{c}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Anything else? (optional)</label>
              <textarea data-testid="drive-message" value={form.message} onChange={update('message')} rows={4} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:border-orange-500 focus:outline-none" placeholder="Vehicle make/model, experience, availability…" />
            </div>
            {error && <p data-testid="drive-error" className="text-sm text-red-400">{error}</p>}
            <button data-testid="drive-submit" type="submit" disabled={status === 'sending'} className="w-full px-6 py-4 rounded-full bg-orange-500 text-black font-semibold hover:bg-orange-400 transition-colors disabled:opacity-60">
              {status === 'sending' ? 'Sending…' : 'Apply to drive'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default DriveWithUs;
